import { NumberUtils } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

const toDecimalValue = (value: unknown): number | undefined => {
  if (value && typeof value === 'object' && 'value' in value) {
    const parsed = parseFloat((value as { value: string }).value);
    return isNaN(parsed) ? undefined : parsed;
  }
  return undefined;
};

const DecimalChangeRender = ({ change }: ActivityChangeOptions) => (
  <ActivityTagItem
    oldValue={NumberUtils.formatRatioAsPercentage(
      toDecimalValue(change.oldValue),
    )}
    newValue={NumberUtils.formatRatioAsPercentage(
      toDecimalValue(change.newValue),
    )}
  />
);

export const METRIC_DECIMAL_CHANGE_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-decimal-change',
    predicate: ({ change }) => change.fieldPath === '/default_effect_size',
    render: DecimalChangeRender,
  });
